import React from "react";
import PropTypes from "prop-types";

import { LogoImage } from "./Theme";

function Form({ children,  ...props }) {
  return <form className="zds-card zds-form-container" {...props}>{children}</form>;
}

Form.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
};

function HeaderForm() {
  return (
    <div className="zds-form-header">
      <LogoImage />
    </div>
  );
}

function DescriptionForm({ title, description }) {
  return (
    <div className="zds-form-description">
      {title && <h2 className="zds-font-heading-small zds-text-system-neutral-800">
        {title}
      </h2>}
      {description && <p className="zds-text-system-neutral-800 zds-font-body-medium">
        {description}
      </p>}
    </div>
  );
}

DescriptionForm.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

function ContentForm({ children }) {
  return <div className="zds-form-content">{children}</div>;
}

ContentForm.propTypes = {
  children: PropTypes.node.isRequired,
};

function FooterForm({ children }) {
  return <div className="zds-form-footer">{children}</div>;
}

FooterForm.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Form, HeaderForm, DescriptionForm, ContentForm, FooterForm }
